import { Component } from '@angular/core';

@Component({
  selector: 'nty-cm-tiered-page',
  imports: [],
  templateUrl: './cm-tiered-page.component.html',
  styleUrls: ['./cm-tiered-page.component.scss'],
})
export class NtyCmTieredPageComponent {}
